<template>
  <div
    :id="`ccd-export-${postFixer}`"
    :class="['ccd-export-contacts', `ccd-export-${postFixer}`]"
  >
    <div class="export-filter-condtions">
      <div
        v-if="showSelectBuilding"
        class="building-multi-select"
        :class="showBuildingError"
      >
        <label class="emphasis">{{ $t('project.building') }}</label>
        <HKLMultiSelect
          class="building-multi-select__control"
          :value="pickedBuildingCodes"
          :options="buildingHklOptions"
          placeholder=""
          @change="onBuildingsChange"
        />
      </div>
      <slot name="addtional-content" />
    </div>
  </div>
</template>

<script>
import lodash from 'lodash'
import { mapGetters } from 'vuex'
import { ref, computed, unref } from 'vue-demi'
import HKLMultiSelect from '@/controls/Select/HKLMultiSelect.vue'

export default {
  name: 'BaseExportContact',
  components: {
    HKLMultiSelect,
  },
  props: {
    postFixer: {
      type: String,
      default: 'contact',
    },
    buttons: {
      type: Array,
      default: () => [],
    },
    inputRequireHighlight: {
      type: Boolean,
      default: false,
    },
    showSelectBuilding: {
      type: Boolean,
      default: true,
    },
    maxBuildingsPerExport: {
      type: Number,
      default: 5,
    },
  },
  setup (props, { emit }) {
    const pickedBuildingCodes = ref([])
    const showBuildingError = computed(() => {
      return { 'required-error-highlight': props.inputRequireHighlight && unref(pickedBuildingCodes).length === 0 }
    })
    const onBuildingsChange = (codes) => {
      const codeList = Array.isArray(codes) ? codes : []
      const limited = codeList.length > props.maxBuildingsPerExport
        ? codeList.slice(0, props.maxBuildingsPerExport)
        : codeList
      pickedBuildingCodes.value = limited
    }
    return {
      showBuildingError,
      pickedBuildingCodes,
      onBuildingsChange,
    }
  },
  computed: {
    ...mapGetters('user', ['currentUser']),
    buildingOptions () {
      const buildings = this.currentUser.buildings.map(building => { return {code: building.code, id: building.id} })
      return lodash.uniqBy(buildings, 'id')
    },
    buildingHklOptions () {
      return (this.buildingOptions || []).map((building) => ({
        name: building.code,
        value: building.code,
      }))
    },
    selectedBuildingObjects () {
      return (this.pickedBuildingCodes || [])
        .map((code) => this.buildingOptions.find((building) => building.code === code))
        .filter(Boolean)
    },
  },
  watch: {
    selectedBuildingObjects (buildings) {
      this.$emit('update:selectedBuildings', buildings)
    },
  },
}
</script>
<style lang="scss" scoped>
.ccd-export-contacts {
  .tms-header {
    background: #ebebeb;
  }
  .export-filter-condtions {
    padding: 20px 24px;
    .building-multi-select {
      width: 200px;
    }
  }

}
</style>
